import { combineReducers } from 'redux';

import { authReducer } from '../components/reducers/authReducer';
import { authPermissionsReducer } from '../components/reducers/authPermissionsReducer';
import { doctorReducer } from '../components/reducers/doctorReducer';
import { patientReducer } from '../components/reducers/patientReducer';
import { reservaPeritoReducer } from '../components/reducers/reservaPeritoReducer';
import { companyReducer } from '../components/reducers/companyReducer';
import { configReducer } from '../components/reducers/configReducer';
import { scheduleReducer } from '../components/reducers/scheduleReducer';
import { customerCareReducer } from '../components/reducers/customerCareReducer';
import { uiReducer } from '../components/reducers/uiReducer';
import { dashboardReducer } from '../components/reducers/dashboardReducer';
import { fileFoldersReducer } from '../components/reducers/fileFoldersReducer';

const reducers = combineReducers({
    ui: uiReducer,
    auth: authReducer,
    doctor: doctorReducer,
    patient: patientReducer,
    company: companyReducer,
    reservaperito: reservaPeritoReducer,
    config: configReducer,
    schedule: scheduleReducer,
    customerCare: customerCareReducer,
    authPermissions: authPermissionsReducer,
    dashboard: dashboardReducer,
    fileFolders: fileFoldersReducer
});

export default reducers;